// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3N026","header":"ReportDetails_header__3OiOd","title":"ReportDetails_title__1jL1e","left":"ReportDetails_left__2WzM6"};